import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TestOption from "../compnents/TestOption";
import TestSelectOption from "../compnents/TestSelectOption";
import TestTitle from "../compnents/TestTitle";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelctText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    marginTop: 20,
    marginBottom: 10,
  },
}));

const MarathonQuestionElement = ({
  question,
  setQuestion,
  optionA,
  setOptionA,
  optionB,
  setOptionB,
  optionC,
  setOptionC,
  optionD,
  setOptionD,
  correctAnswer,
  setCorrectAnswer,
  category,
  setCategory,
  score,
  setScore,
}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <TestTitle value={question} handeChange={(value) => setQuestion(value)} />

      <TestOption
        text={"الف"}
        type={"text"}
        value={optionA}
        handleChange={(value) => setOptionA(value)}
      />
      <TestOption
        text={"ب"}
        type={"text"}
        value={optionB}
        handleChange={(value) => setOptionB(value)}
      />
      <TestOption
        text={"ج"}
        type={"text"}
        value={optionC}
        handleChange={(value) => setOptionC(value)}
      />
      <TestOption
        text={"د"}
        type={"text"}
        value={optionD}
        handleChange={(value) => setOptionD(value)}
      />

      <TestSelectOption
        title={"گزینه صحیح"}
        value={correctAnswer}
        handleChange={(value) => setCorrectAnswer(value)}
        options={[
          { optName: optionA, value: "optionA" },
          { optName: optionB, value: "optionB" },
          { optName: optionC, value: "optionC" },
          { optName: optionD, value: "optionD" },
        ]}
      />


      <TestSelectOption
        title={" دسته بندی سوال"}
        value={category}
        handleChange={(value) => setCategory(value)}
        options={[
          {
            optName: "کتاب شناسی و فرهنگ مطالعه",
            value: "کتاب شناسی و فرهنگ مطالعه",
          },
          {
            optName: "ایران شناسی و هویت ملی",
            value: "ایران شناسی و هویت ملی",
          },
          {
            optName: "بهره وری در کار و صنعت",
            value: "بهره وری در کار و صنعت",
          },
          {
            optName: "مذهبی، اخلاقی و احکام روزمره",
            value: "مذهبی، اخلاقی و احکام روزمره",
          },
          {
            optName: "خانواده، تربیت و سبک زندگی فرهنگی",
            value: "خانواده، تربیت و سبک زندگی فرهنگی",
          },
          {
            optName: "تاریخ ایران و جهان",
            value: "تاریخ ایران و جهان",
          },
          {
            optName: "علم، طبیعت و دانش عمومی",
            value: "علم، طبیعت و دانش عمومی",
          },
          {
            optName: "هنری و ورزشی",
            value: "هنری و ورزشی",
          },
          {
            optName: "سوال طلایی",
            value: "سوال طلایی",
          },
        ]}
      />

      <TestOption
        text={""}
        title={"امتیاز"}
        type={"number"}
        value={score}
        handleChange={(value) => setScore(+value)}
      />
    </React.Fragment>
  );
};

export default MarathonQuestionElement;
